import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BareElement from '../BareElement/BareElement';
import shallowEqual from 'fbjs/lib/shallowEqual';

export default class BackgroundElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    const clonedProps = _.clone(this.props);
    _.assign(clonedProps.compProps, {
      zIndex: -1100
    });
    return (
      <BareElement {...clonedProps} />
    );
  }
}

BackgroundElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
    height: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired])
  })
};